import moment from 'moment'

import Column, { ColumnFooter } from '../Column/index'
import ConfirmationDialog from '../ConfirmationDialog/index'
import styles from './MatchesDialog.module.scss'

const MatchesDialog = ({ matches, handleClose }) => (
  <ConfirmationDialog
    title="Matched bookings"
    positiveMessage="Back to blacklisting"
    theme="blacklist"
    onConfirm={handleClose}
    onClose={handleClose}
  >
    <Column isFullWidth>
      {matches.subsidiaries.map(match => (
        <Match {...match} key={match.subsidiaryName} />
      ))}
      <Total totalConversionsEffected={matches.totalConversionsEffected} />
    </Column>
  </ConfirmationDialog>
)

const Match = ({ subsidiaryName, totalConversionsEffected }) => (
  <div className={styles.match}>
    <div className={styles.matchLabel}>
      <p className={styles.subsidiary}>{subsidiaryName}</p>
      <p className={styles.desc}>{moment().format('MMMM')} conversions</p>
    </div>
    <div className={styles.matchNumber}>{totalConversionsEffected}</div>
  </div>
)

const Total = ({ totalConversionsEffected }) => (
  <ColumnFooter>
    <div className={styles.total}>
      <div className={styles.matchLabel}>
        <p className={styles.subsidiary}>Total</p>
      </div>
      <div className={styles.matchNumber}>{totalConversionsEffected}</div>
    </div>
  </ColumnFooter>
)

export default MatchesDialog
